$(() => {

	const trigger = $('.x__trigger'),
		resultsWrapper = $('.x__results');

	if (!trigger.length) {
		return;
	}

	trigger.on('click', function (event) {
		event.preventDefault();

		$.ajax({
			url: blogAjax.ajax_url,
			dataType: 'json',
			type: 'get',
			data: {
				action: 'posts_ajax',
				ajax: true,
				offset: trigger.data('offset'),
				tag_id: trigger.data('tag-id')
			},

			success: function (response) {
				if (response.error) {
					resultsWrapper.html(response.error);
				}
				if (response.showbtn) {
					trigger.removeClass('hide');
					trigger.addClass('show');
				} else {
					trigger.removeClass('show');
					trigger.addClass('hide');
				}
				if (response.success && response.success.html) {
					var elems = response.success.html;
					resultsWrapper.append(elems);
					trigger.data('offset', response.success.offset);
				}

			},
			error: function (error) {
				console.log('error');
			}
		});
	})
});



// WEBPACK FOOTER //
// ./assets/scripts/ajax-post.js